import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import founderImage from './founder.jpg'; // Ensure the path to the image is correct
import './ShivendraJha.css';

const ShivendraJha = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);

    // Simulate content loading for demonstration
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust to your content loading time
  }, []);

  const textRef = useRef(null);

  const handleScroll = () => {
    if (textRef.current) {
      const textPosition = textRef.current.getBoundingClientRect().top;
      console.log(textPosition);
    } else {
      console.error('Element not found!');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>Shivendra Jha - Founder of TureMedicine</title>
        <meta name="description" content="Learn about Shivendra Jha, the visionary founder of TureMedicine, revolutionizing telehealthcare in India." />
        <meta name="keywords" content="Shivendra Jha, TureMedicine, Founder, Telehealthcare in India, Healthcare Accessibility" />
        <meta name="author" content="Shivendra Jha" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Shivendra Jha",
            "jobTitle": "Founder of TureMedicine",
            "url": "https://turemedicine.com/shivendra-jha",
            "image": "https://turemedicine.com/static/media/founder.8625846b2a5bc41eb731.jpg",
            "sameAs": [
              "https://linkedin.com/in/shivendra-jha",
              "https://twitter.com/shivendra_jha"
            ],
            "description": "Shivendra Jha is the visionary founder of TureMedicine, transforming telehealthcare in India."
          })}
        </script>
      </Helmet>
      <Navbar />
      <div className="shivendra-page">
        {/* Hero Section */}
        <div className="hero-section">
          <h1>Shivendra Jha</h1>
          <p>
            Founder & CEO of TureMedicine, Shivendra Jha is a technology enthusiast with a passion
            for revolutionizing healthcare accessibility in India. Combining innovation with
            compassion, he has dedicated his career to building solutions that bring healthcare
            closer to everyone, no matter their location.
          </p>
        </div>

        {/* Content Section */}
        <div className="content-section">
          <div className="founder-image-container">
            <img
              src={founderImage}
              alt="Shivendra Jha - Founder of TureMedicine"
              className="founder-image"
            />
          </div>
          <h2 ref={textRef}>About Shivendra Jha</h2>
          <p>
            Shivendra holds expertise in software development and healthcare technologies. His
            vision for TureMedicine stems from a deep understanding of the challenges in India&apos;s
            healthcare system. He believes in leveraging technology to bridge the gap between
            patients and doctors.
          </p>
          <p>
            Under Shivendra&apos;s leadership, TureMedicine has grown into a platform that connects
            people across India with qualified medical professionals, ensuring access to quality
            care for all.
          </p>
        </div>

        {/* Loading Indicator (Optional) */}
        {loading && (
          <div className="loading-indicator">
            <p>Loading...</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default ShivendraJha;
